import { Observable, catchError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';
import { GetVesselsResponse } from '@navstation-portal/vessels/data-model/vessel';

@Injectable({ providedIn: 'root' })
export class VesselsService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('Vessels');

  getVessels(emailAddress: string): Observable<GetVesselsResponse> {
    return this.http
      .get<GetVesselsResponse>(`${this.baseUrl}/${emailAddress}/vessels`)
      .pipe(catchError(this.apiError.toApiError('getting vessels')));
  }
}
